import { useEffect } from 'react';

/**
 * Sets document.title contextually.
 * Usage: usePageTitle('Project Name', 'Site Name')
 * Result: "Project Name — Site Name"
 * If only siteName: "Site Name"
 */
export function usePageTitle(pageTitle?: string | null, siteName?: string | null) {
  useEffect(() => {
    if (!pageTitle && !siteName) return;
    
    if (pageTitle && siteName) {
      document.title = `${pageTitle} — ${siteName}`;
    } else if (pageTitle) {
      document.title = pageTitle;
    } else if (siteName) {
      document.title = siteName;
    }
  }, [pageTitle, siteName]);
}
